import React from 'react'
import {TableBody} from "./TableBody";
import {TableHead} from "./TableHead";
import {ResponsiveTable} from "../../../layout/Table/ResponsiveTable";

const TableComponent = (props) => {

  return (
    <ResponsiveTable>
      <TableHead
        applySort={ props.applySort }
      />
      <TableBody
        items={ props.items }
        actionCallback={ props.actionCallback }
      />
    </ResponsiveTable>
  )
}

export { TableComponent }
